export const pinSecurityValidation = (newPin: string) => {
    const halfLen = Math.floor(newPin.length * 0.5)
    //case: reversal
    const first = newPin.slice(0, halfLen)
    const last = newPin.split('').reverse().slice(0, halfLen).join('') // string.Join("", newPin.TakeLast(halfLen).Reverse());
    if (first === last) return false

    //case use repeat group number in all pin
    const groupRepeatNumber = RegExp('([\\d]+)\\1', 'g')
    let matches = groupRepeatNumber.exec(newPin)
    if (
        matches &&
        (matches[1].length > 1 ||
            (matches[1].length === 1 && matches[0].length > halfLen))
    )
        return false
    //numpad case
    const groupInput = new RegExp('[0-9]{3}', 'g')
    let inputPart
    while ((inputPart = groupInput.exec(newPin))) {
        var result = inputPart[0].split('').map((a) => parseInt(a))
        if (
            (result[2] - result[0]) / 2 !== result[1] - result[0] ||
            result[2] === result[0]
        )
            return true
    }

    return false
}
